module.exports = __webpack_public_path__ + "static/media/JM.8d16c476.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/JM.svg
// module id = 283
// module chunks = 0